import { Component, ViewContainerRef } from '@angular/core';
import { AuthenticationService, ToastrService } from './_services/index';
import { NavigationEnd, Router } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    providers: [ToastrService]
})
export class AppComponent {
    title = 'Teacher Created Materials';
    headerHeight: any = null;
    constructor(_authenticationService: AuthenticationService,
        public router: Router,
        public toastr: ToastsManager,
        vRef: ViewContainerRef) {
        //Set toastr container ref configuration for toastr positioning on screen
        this.toastr.setRootViewContainerRef(vRef);

        // Fixed - page refresh always navigate to home.
        // if (_authenticationService.isLoggedIn()) {
        //     this.router.navigate(['home']);
        // }
        $(document).ready(()=>{
            this.headerHeight = $("#app-header-elem")[0].offsetHeight;
        })
        $(window).resize(()=>{
            this.headerHeight = $("#app-header-elem")[0].offsetHeight;
        })
    }
}



// WEBPACK FOOTER //
// ./public/app/app.component.ts